import { render, staticRenderFns } from "./godObmen.vue?vue&type=template&id=3a1607e2&scoped=true&"
import script from "./godObmen.vue?vue&type=script&lang=js&"
export * from "./godObmen.vue?vue&type=script&lang=js&"
import style0 from "./godObmen.vue?vue&type=style&index=0&id=3a1607e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1607e2",
  null
  
)

export default component.exports